export default __webpack_public_path__ + "static/media/LeaveAPart.14935482.mp3";